module.exports = __webpack_public_path__ + "static/media/button-menu.4cacba0e.svg";